import React, { Component } from "react";
import pubsub from "pubsub-js";
import { Collapse } from "reactstrap";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

const BootstrapButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#010928"),
  backgroundColor: "#010928",
  "&:hover": {
    backgroundColor: "#343e61",
  },
  fontSize: 10,
  padding: "3px 6px",
  border: "1px solid",
  borderRadius: "30px",
  textTransform: "none",
}));


class SidebarUserBlock extends Component {
  state = {
    userBlockCollapse: false,
    username: this.props.User.SideBarConfig.UserName,
    userlastmane: this.props.User.SideBarConfig.UserNameLast,
    idRol: this.props.User.SideBarConfig.RoleId,
    Rol: this.props.User.SideBarConfig.Rol,
    UserId: this.props.User.SideBarConfig.UserId,
  };

  componentDidMount() {
    this.pubsub_token = pubsub.subscribe("toggleUserblock", () => {
      this.setState({
        userBlockCollapse: !this.state.userBlockCollapse,
      });
    });
  }

  componentWillUnmount() {
    pubsub.unsubscribe(this.pubsub_token);

    // this.setState({
    //   userBlockCollapse: !this.state.userBlockCollapse,
    // });
  }

  showGeneralInfo = () => {
    this.props.history.push(`/myprofile/${this.state.UserId}`);
  };

  render() {
    let { username, userlastmane, Rol } = this.state;
    return (
      <Collapse id="user-block" isOpen={this.state.userBlockCollapse}>
        <div>
          <div style={{ textAlign: "center" }} className="item user-block">
            {/* User picture */}
            <div className="user-block-picture">
              <div className="user-block-status">
                <img
                  className="img-thumbnail rounded-circle"
                  src="https://fsposeidon.blob.core.windows.net/files/user-default-grey.png"
                  alt="Avatar"
                  width="80"
                  height="80"
                />
              </div>
            </div>
            {/* Name and Job */}
            <div className="user-block-info">
              <span className="user-block-name">
                Hola, {username} {userlastmane}
              </span>
              <span className="user-block-role" style={{ marginBottom: "5px" }}>
                {Rol}
              </span>
              <BootstrapButton
                variant="contained"
                disableRipple
                style={{
                  color: "#aaa",
                }}
                onClick={this.showGeneralInfo}
              >
                Ver perfil
              </BootstrapButton>
            </div>
          </div>
        </div>
      </Collapse>
    );
  }
}

export default SidebarUserBlock;
